import {Breakpoints, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiPopover = ({popoverTooltip}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiPopover: {
    defaultProps: {},
    styleOverrides: {
      /* Styles applied to the root element. */
      root: {
        '&[data-popper-placement*="bottom"] .arrow': {
          top: 0,
          left: 'calc(50% - 8px)',
          marginTop: '-8px',
          boxShadow: '-1px -1px 0 #323334'
        },
        '&[data-popper-placement*="bottom-end"] .arrow': {
          top: 0,
          left: 'calc(90% - 8px)',
          marginTop: '-8px',
          boxShadow: '-1px -1px 0 #323334'
        },
        '&[data-popper-placement*="bottom-start"] .arrow': {
          top: 0,
          left: 'calc(10% - 8px)',
          marginTop: '-8px',
          boxShadow: '-1px -1px 0 #323334'
        },
        '&[data-popper-placement*="top"] .arrow': {
          top: 'calc(100% - 8px)',
          left: 'calc(50% - 8px)',
          '&:before': {
            marginLeft: '-3px',
            marginTop: '-3px'
          }
        },
        '&[data-popper-placement*="right"] .arrow': {
          left: 0,
          marginLeft: '-8px',
          '&:before': {
            marginLeft: '1px',
            marginTop: '-3px'
          }
        },
        '&[data-popper-placement*="left"] .arrow': {
          right: 0,
          marginRight: '-8px',
          '&:before': {
            marginLeft: '-3px',
            marginTop: '1px'
          }
        },
        '& .arrow': {
          position: 'absolute',
          width: '16px',
          height: '16px',
          boxSizing: 'border-box',
          top: 'calc(50% - 8px)',
          backgroundColor: popoverTooltip?.container.desktop.border.color,
          transform: 'rotate(45deg)',
          boxShadow: '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12)',
          '&:before': {
            content: '""',
            display: 'block',
            backgroundColor: popoverTooltip?.container.desktop.background.color,
            height: '18px',
            width: '18px'
          }
        }
      },
      paper: {
        backgroundColor: popoverTooltip?.container.desktop.background.color,
        borderColor: popoverTooltip?.container.desktop.border.color,
        borderStyle: popoverTooltip?.container.desktop.border.style,
        borderWidth: popoverTooltip?.container.desktop.border.width,
        borderRadius: popoverTooltip?.container.desktop.border.radius,
        padding: 16, // popoverTooltip?.container.desktop.padding.all,
        overflow: 'unset',
        boxShadow: '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12)',
        [mediaQueries.up('sm')]: {
          maxWidth: '272px'
        },
        [mediaQueries.up('md')]: {
          maxWidth: '408px'
        },
        '& .popoverTitle': {
          color: popoverTooltip?.title.desktop.font.color,
          fontSize: popoverTooltip?.title.desktop.font.size,
          fontWeight: popoverTooltip?.title.desktop.font.weight,
          lineHeight: popoverTooltip?.title.desktop.font.lineHeight,
          marginBottom: 4,
          [mediaQueries.down('sm')]: {
            fontSize: popoverTooltip?.title.mobile.font.size,
            fontWeight: popoverTooltip?.title.mobile.font.weight,
            lineHeight: popoverTooltip?.title.mobile.font.lineHeight
          }
        },
        '& .popoverBody': {
          color: popoverTooltip?.description.desktop.font.color,
          fontSize: popoverTooltip?.description.desktop.font.size,
          fontWeight: popoverTooltip?.description.desktop.font.weight,
          lineHeight: popoverTooltip?.description.desktop.font.lineHeight,
          [mediaQueries.down('sm')]: {
            fontSize: popoverTooltip?.description.mobile.font.size,
            fontWeight: popoverTooltip?.description.mobile.font.weight,
            lineHeight: popoverTooltip?.description.mobile.font.lineHeight
          }
        },
        '& .iconButton-popoverClose': {
          color: popoverTooltip?.close.desktop.icon.color
        }
      }
    }
  }
});
